import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=92b226e8"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('/opt/build/repo/components/Logo.vue').default,LayoutNavMenu: require('/opt/build/repo/components/layout/NavMenu.vue').default,ScLangSwitcher: require('/opt/build/repo/node_modules/@evince/site/lib/packages/LangSwitcher.vue').default,LoginLink: require('/opt/build/repo/components/LoginLink.vue').default,RegisterButton: require('/opt/build/repo/components/register/Button.vue').default,ScMobileMenu: require('/opt/build/repo/node_modules/@evince/site/lib/packages/MobileMenu.vue').default})
